/**
* IBM Confidential
* Licensed Materials - Property of IBM
* (C) Copyright IBM Corp. 2020, 2024 All Rights Reserved.
* US Government Users Restricted Rights - Use, duplication or
* disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
* */

import PropTypes from 'prop-types';
import React from 'react';

var TableSettingsOption = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("li", {
    ref: ref,
    className: "cds--table-settings-menu__option"
  }, children);
});
TableSettingsOption.propTypes = {
  /**
   * Specify the contents of the ToolbarOption
   */
  children: PropTypes.node.isRequired
};
var TableSettingsOption$1 = TableSettingsOption;

export { TableSettingsOption$1 as default };
